import type {
  PlayerOrgRatingAllResponsePagedData,
  PlayerProfileResponse,
} from '@on3/api';

import { ConsensusModule } from './ConsensusModule';
import styles from './IndustryComparisonComponent.module.scss';
import { RankingServiceModule } from './RankingServiceModule';

interface IPlayerAllRankingPageProps {
  basicInfo?: PlayerProfileResponse;
  allRankingList?: PlayerOrgRatingAllResponsePagedData;
}

export const IndustryComparisonComponent = ({
  allRankingList,
  basicInfo,
}: IPlayerAllRankingPageProps) => {
  const industryRanking = allRankingList?.list?.[0].ratings?.find(
    (rank) => rank.type === 'Industry',
  );
  const services = allRankingList?.list?.[0].ratings?.filter(
    (rank) => rank.type !== 'Consensus' && rank.type !== 'Industry',
  );
  const isRivalsRating =
    !!industryRanking?.rankingYear && industryRanking.rankingYear > 2025;

  return (
    <div className={styles.wrapper}>
      <ConsensusModule basicInfo={basicInfo} consensus={industryRanking} />
      <div className={styles.servicesHeader}>
        <span className={styles.source}>Source</span>
        <span className={styles.labels}>
          <span aria-label="National">Natl</span>{' '}
          <span>{industryRanking?.positionAbbr || 'POS'}</span>
          <span>{industryRanking?.stateAbbr || 'ST'}</span>
        </span>
      </div>
      <div className={styles.services}>
        {services ? (
          services?.map((ranking) => {
            if (isRivalsRating && ranking.type === 'Rivals') return null;

            return (
              <RankingServiceModule
                key={`${ranking.rankingKey}-${ranking.type}`}
                {...ranking}
              />
            );
          })
        ) : (
          <p>No Rankings</p>
        )}
      </div>
    </div>
  );
};
